export default __webpack_public_path__ + "static/media/1_0028.9d4a8d28.webp";